/*
 * @Author: yangyang yyangacom@163.com
 * @Date: 2024-05-22 10:57:37
 * @LastEditors: yangyang yyangacom@163.com
 * @LastEditTime: 2024-05-23 18:52:26
 * @FilePath: /dbrank_b/src/routes/visualChart/P26/index.js
 * @Description: p26
 */
import React from 'react';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import s from './index.css';
import Stage from '../components/Stage';
import setChart from './chart';
import Chart from '../components/Chart';
import { Title26 } from '../components/Titles';
import TooltipDrawer from '../components/TooltipDrawer';
import Form from './Form';
import DBTable from '../components/DBTable';
import { applyThousands } from '../utils';

function formatThousands(event) {
  if (event.target.innerHTML) {
    event.target.innerHTML = event.target.innerHTML
      .replace(/(\d),(\d)/g, "$1$2")
      .replace(/(\d)(?=(\d{3}\D?)+(\D|$))/g, "$1,");
  }
}
function reverseExceptFirst(arr) {
  // 获取除第0项以外的所有项
  var rest = arr.slice(1);
  // 将这些项倒序
  rest.reverse();
  // 将第0项和倒序后的项连接回数组
  return [arr[0]].concat(rest);
}

class P26 extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      chartTitle: [],
      chartList: [],
      tableColumns: [],
      tableList: [],
      tableColorList: [],
      mySize: {  // 模版大小
        width: 510, 
        height: 680 
      },
      padding: '0 0'
    }
  }




  render() {
    const { mySize, chartTitle, chartList, tableColumns, tableList, tableColorList } = this.state;
    const border = `2px solid ${tableColorList[2]}`
    console.log('tableColorList', tableColorList)
    console.log('tableList', tableList)
    return (
      <Stage size={mySize} padding={this.state.padding}>
        <div className={s.box}>
          <Title26 pageNumber="3.5">ESG传播影响力最高媒体源TOP10
          </Title26>
          <div className={s.content}>
            <div contentEditable onBlur={formatThousands} className={s.des}>
              2023年，
              ESG话题相关内容传播影响力最高的媒体源是<span className={s.fontColor}>人民日报/人民网</span>，
              数字品牌价值为<span className={s.fontColor} contentEditable>1,458,142,60</span><span className={s.fontColor}><i>DB</i></span>，内容条数为3,700条；
              排名第二的媒体源为<span className={s.fontColor}>新京报</span>，内容条数为3,559条，数字品牌价值为<span className={s.fontColor}>390,703,098</span><span className={s.fontColor}><i>DB</i></span>；
              新华社/新华网位列第三，贡献<span className={s.fontColor}>281,225,648</span><span className={s.fontColor}><i>DB</i></span>的数字品牌价值。
            </div>
            <div contentEditable onBlur={formatThousands} className={s.des}>
              TOP10媒体中，
              <span className={s.fontColor}>界面财联社</span>的内容条数最多，为
              <span className={s.fontColor}>5,583</span>条。
            </div>
            <div className={s.uiWrapper}>

              <div className={s.tableWrapper}>
                <TooltipDrawer formContent={<Form onChange={values => this.setState({ ...values })} />}>

                  <div className={s.tableBox}>
                    <ul className={s.tableBox_ul}>
                      {
                        tableList.length > 0 ?
                         reverseExceptFirst(Object.values(applyThousands(tableList)[0])).map((item, index) => (
                            <li key={index}>{item}</li>
                          ))
                        : null
                      }
                    </ul>
                  </div>
                </TooltipDrawer>
              </div>
              <div className={s.chartWrapper}>
                <Chart isShow options={setChart({ title: chartTitle, list: chartList, color: tableColorList })} />
              </div>
            </div>
          </div>
        </div>
      </Stage>
    );
  }
}

export default withStyles(s)(P26);



// WEBPACK FOOTER //
// src/routes/visualChart/P26/index.js